import { getVeloConstant } from '../../react/shared/lib/veloConstants'
import { hasCooldownExpired, markBannerAsShown } from './mobileAppPromoBannerCooldown'

const DELAY_SECONDS = 20
const SLIDE_DURATION_MS = 700

function showBanner(banner: HTMLElement) {
  banner.classList.remove('hidden')

  // Let the browser paint the hidden->visible frame first so the slide-in
  // transition actually runs instead of the banner appearing in place.
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      banner.classList.remove('-translate-y-full')
    })
  })

  markBannerAsShown()
}

function hideBanner(banner: HTMLElement) {
  banner.classList.add('-translate-y-full')

  setTimeout(() => {
    banner.classList.add('hidden')
  }, SLIDE_DURATION_MS)
}

export function initMobileAppPromoBanner() {
  const banner = document.getElementById('mobile-app-promo-banner')
  if (!banner) {
    return
  }

  // Missing constants default to "suppress the promo" (premium=false would
  // show it, hasUsedMobileApp=true hides it) — same convention as the React
  // store promos.
  const isPremiumUser = getVeloConstant('isPremiumUser', false)
  const hasUsedMobileApp = getVeloConstant('hasUsedMobileApp', true)
  if (isPremiumUser || hasUsedMobileApp) {
    return
  }

  if (!hasCooldownExpired()) {
    return
  }

  const closeButton = banner.querySelector('[data-role="mobile-app-promo-banner-close"]')
  closeButton?.addEventListener('click', () => {
    hideBanner(banner)
  })

  setTimeout(() => {
    showBanner(banner)
  }, DELAY_SECONDS * 1000)
}
